// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SettingsByRangeItemDraggable HO component
 */
import { compose } from 'recompose';
import draggable from 'share/components/hoc/Izenda.Draggable';
import droppable from 'share/components/hoc/Izenda.Droppable';
import SettingsByRangeItem from './Izenda.SettingsByRangeItem';

const dndId = 'SettingsByRangeItemDnd';

const dragOptions = {
  beginDrag(props) {
    return {
      itemIndex: props.itemIndex
    }
  }
};

const dropOptions = {
  hover(props, monitor) {
    const dragIndex = monitor.getItem().itemIndex;
    const hoverIndex = props.itemIndex;
    if (dragIndex === hoverIndex)
      return;
    props.onMove && props.onMove(dragIndex, hoverIndex);
    monitor.getItem().itemIndex = hoverIndex;
  }
};

const droppableRow = droppable(dndId, dropOptions);
const draggableRow = draggable(dndId, dragOptions, false);

export default compose(draggableRow, droppableRow)(SettingsByRangeItem);




// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/CommonSettings/Izenda.SettingsByRangeItemDraggable.js